import { render, staticRenderFns } from "./Auth0MigrationFeatureDisabledModal.vue?vue&type=template&id=6514ecf2&scoped=true"
import script from "./Auth0MigrationFeatureDisabledModal.vue?vue&type=script&lang=js"
export * from "./Auth0MigrationFeatureDisabledModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6514ecf2",
  null
  
)

export default component.exports